<template>
    <div>
      <el-row>
        <el-col :span="12">
          <el-table
            stripe
            :data="userlist"
            ref="wx_userlist">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              min-width="30px"
              prop="openid"
              label="OpenId"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              width="120px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="查看用户" placement="top-start">
                  <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="getuserinfo(scope.$index, userlist)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12">
          <el-form label-width="100px" label-position="left" style="margin-left:30px;">
            <el-form-item label="昵称:">
              <el-input
                type="text"
                autosize=""
                placeholder="昵称"
                v-model="nickname">
              </el-input>
            </el-form-item>
            <el-form-item label="国家:">
              <el-input
                type="text"
                autosize=""
                placeholder="请输入标题"
                v-model="country">
              </el-input>
            </el-form-item>
            <el-form-item label="省：">
              <el-input
                type="text"
                autosize=""
                placeholder="请输入标题"
                v-model="province">
              </el-input>
            </el-form-item>
            <el-form-item label="市：">
              <el-input
                type="text"
                autosize=""
                placeholder="请输入标题"
                v-model="city">
              </el-input>
            </el-form-item>
            <el-form-item label="头像：">
              <el-image
                style="width: 100px; height: 100px"
                :src="imgurl"></el-image>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
Vue.prototype.$http = axios
var that
export default {
  name: 'WxUser',
  data () {
    return {
      userlist: [],
      imgurl: '',
      city: '',
      nickname: '',
      country: '',
      province: ''
    }
  },
  mounted () {
    that = this
    that.getuserlist()
  },
  methods: {
    async getuserinfo (index, data) {
      var at = await getaccesstoken()
      window.console.log(at)
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/getuserbyopenid',
        method: 'post',
        data: {
          accesstoken: at,
          openid: data[index].openid
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            var tmpdata = JSON.parse(res.data.data)
            window.console.log(tmpdata)
            that.nickname = tmpdata.nickname
            that.imgurl = tmpdata.headimgurl
            that.city = tmpdata.city
            that.country = tmpdata.country
            that.province = tmpdata.province
            window.console.log(that.imgurl)
            // 把相关数据缓存到本地
          } else {
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    async getuserlist () {
      var at = await getaccesstoken()
      window.console.log(at)
      var adata = {
        accesstoken: at
      }
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/getuseropenids',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            var tmpdata = JSON.parse(res.data.data)
            window.console.log(tmpdata)
            that.userlist = []
            for (var i = 0; i < tmpdata.data.openid.length; i++) {
              var data = {
                openid: tmpdata.data.openid[i]
              }
              that.userlist.push(data)
            }
            // 把相关数据缓存到本地
          } else {
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    }
  }
}
  async function getaccesstoken () {
    return new Promise(resolve => {
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/getaccesstoken',
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          window.console.log(res)
          if (res.status === 200) {
            window.console.log(res.data)
            resolve(res.data)
          } else {
            window.console.log('返回错误')
            resolve('')
          }
        })
        .catch(function (error) {
          window.console.log(error)
          resolve('')
        })
    })
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/wx/WxUser.vue